import React from "react";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { hashCode, turkishCurrencyFormatterNoPrecision } from "../utils";

const ExpenseChart = ({
  expensesTypeGrouped,
  expensesSubTypeGrouped,
  renderCustomizedLabel,
}) => {
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#FF0000",
    "#00FF00",
    "#0000FF",
    "#FFFF00",
    "#FF00FF",
    "#00FFFF",
    "#800000",
    "#008000",
    "#000080",
    "#808080",
  ];

  // Custom Tooltip to format currency and display name
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const { name, value } = payload[0];
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "#fff",
            padding: "5px",
            border: "1px solid #ccc",
          }}
        >
          <p>{name}</p>
          <p>{turkishCurrencyFormatterNoPrecision(value)}</p>
        </div>
      );
    }
    return null;
  };

  // Custom label for the inner pie (name + totalPrice)
  const renderOuterPieLabel = (entry) =>
    `${entry.name.slice(0, 5)}: ${turkishCurrencyFormatterNoPrecision(
      entry.totalPrice
    )}`;

  const renderInnerPieLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    name,
    totalPrice,
  }) => {
    const radius = innerRadius + (outerRadius - innerRadius) / 2; // Center the label
    const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
    const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
    return (
      <text
        x={x}
        y={y}
        fill="black"
        textAnchor="middle"
        dominantBaseline="middle"
        fontWeight="bold"
      >
        {`${name.slice(0, 5)}: ${turkishCurrencyFormatterNoPrecision(
          totalPrice
        )}`}
      </text>
    );
  };

  return (
    <div className="chart-container" style={{ height: "400px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          {/* Outer Pie */}
          <Pie
            data={expensesTypeGrouped.slice()}
            dataKey="totalPrice"
            nameKey="type"
            cx="50%"
            cy="50%"
            innerRadius={20}
            outerRadius={90}
            paddingAngle={5}
            fill="#8884d8"
            labelLine={false}
            label={renderInnerPieLabel}
          >
            {expensesTypeGrouped.map((entry, index) => (
              <Cell
                key={`cell-${index}-${entry.type}`}
                fill={COLORS[hashCode(entry.type) % COLORS.length]}
              />
            ))}
          </Pie>
          {/* Inner Pie */}
          <Pie
            data={expensesSubTypeGrouped}
            dataKey="totalPrice"
            nameKey="_id.subType"
            cx="50%"
            cy="50%"
            paddingAngle={3}
            innerRadius={150}
            outerRadius={170}
            fill="#82ca9d"
            label={renderOuterPieLabel} // Display name + totalPrice
          >
            {expensesSubTypeGrouped.map((entry, index) => (
              <Cell
                key={`cell-${index}-${entry._id.type}`}
                fill={COLORS[hashCode(entry._id.type) % COLORS.length]}
              />
            ))}
          </Pie>
          {/* Tooltip */}
          <Tooltip content={<CustomTooltip />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ExpenseChart;
